/** Only the ordinary teacher home has a replacement textbook card. */
export function showHeaderEbookEntry({
  role,
  useRoleHomePalette,
  canManage,
}: {
  readonly role: 'STUDENT' | 'TEACHER' | 'ADMIN' | undefined;
  readonly useRoleHomePalette: boolean;
  readonly canManage: boolean;
}): boolean {
  return role === 'STUDENT' || (role === 'TEACHER' && (!useRoleHomePalette || canManage));
}

/** The student bookshelf, reader and rankings own their navigation within EBOOKS. */
export function hideStudentEbookTopbar({
  role,
  section,
  hasGameSnapshot,
}: {
  readonly role: 'STUDENT' | 'TEACHER' | 'ADMIN' | undefined;
  readonly section: string;
  readonly hasGameSnapshot: boolean;
}): boolean {
  return role === 'STUDENT' && section === 'EBOOKS' && !hasGameSnapshot;
}
